import { LazyLoad, LazyImg } from './components/';
import hoc from './components/hoc';
import LazyLoadOrigin from './components/lazyLoadOrigin';
import LazyImgOrigin from './components/lazyImgOrigin';
import createObserver from './core/createObserver';
export { LazyImg, createObserver, hoc, LazyImgOrigin, LazyLoadOrigin };
export default LazyLoad;
